<template>
  <el-dialog :visible.sync="show" @close="closeModal">
    <div class="title_popup text-center"><FAIcon icon="fa fa-paper-plane" /> Chia sẻ thư mục</div>
    <el-form v-if="tag" ref="form" label-width="160px" label-position="left">
      <el-form-item label="Tên thư mục">
        <div class="document-title">{{ tag.name }}</div>
      </el-form-item>
      <el-form-item label="Email chia sẻ">
        <el-input
          placeholder="Nhập Email muốn chia sẻ"
          v-model="email"
          @keyup.native.enter="startCheck"
          @keydown.native.tab="startCheck"
        >
          <i
            class="el-icon-success el-input__icon success-email-check-icn"
            slot="suffix"
            v-if="isStartCheck && isRealEmail"
          />
          <i
            class="el-icon-error el-input__icon error-email-check-icn"
            slot="suffix"
            v-else-if="isStartCheck && !isRealEmail"
          />
        </el-input>
      </el-form-item>
      <el-form-item label="Mô tả">
        <el-input type="textarea" :rows="3" placeholder="Mô tả" v-model="description"> </el-input>
      </el-form-item>
      <h5>Thư mục đã được chia sẻ cho {{ tag.sharedUsers.length }} người dùng</h5>
      <div class="shared-tag-list" v-if="tag.sharedUsers.length > 0">
        <el-tag
          class="shared-tag"
          :type="['default', 'success', 'info'][index % 3]"
          v-for="(user, index) in tag.sharedUsers"
          :key="user"
          @close="openCancelShareConfirmDialog(user)"
          closable
        >
          {{ user }}
        </el-tag>
      </div>
    </el-form>
    <el-row type="flex" class="dialog-footer" justify="end">
      <el-button @click="closeModal">Hủy bỏ</el-button>
      <CommonButton type="primary" @click="onSubmitShareTag()">
        Chia sẻ
      </CommonButton>
    </el-row>
  </el-dialog>
</template>

<script>
import { apiShareTag, apiUnshareTag } from "@/services/tag_management_service"
import { TagSharePermissions } from "@/constants/DoITConstant"
import { getEmailExistenceInfo } from "@/services/authentication_service"
import FAIcon from "@/components/common/FAIcon.vue"
import CommonButton from "@/components/common/CommonButton.vue"

export default {
  name: "TagShareModal",
  components: { CommonButton },
  data: function () {
    return {
      show: false,
      mode_page_check: "all",
      loading: false,
      email: "",
      isRealEmail: false,
      isStartCheck: false,
      permissions: [],
      allPermissions: TagSharePermissions,
      description: "",
      id: null,
      isSending: false,
      FAIcon,
      tag: null,
    }
  },
  props: ["info"],
  methods: {
    openModal(tag) {
      this.tag = tag
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    async onSubmitShareTag() {
      this.loading = true
      let res = await apiShareTag(this.tag.id, {
        email: this.email,
        description: this.description,
      })
      if (res != null) {
        this.$message.success("Cập nhật thành công")
        this.$emit("success")
        this.show = false
      } else {
        this.$message.error("Có lỗi xảy ra")
      }
      this.loading = false
    },
    startCheck() {
      this.isStartCheck = true
    },
    openCancelShareConfirmDialog(user) {
      this.$confirm(`Bạn muốn hủy chia sẻ cho người dùng "${user}"?`, "Bạn có chắc chắn hủy chia sẻ?", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        try {
          await apiUnshareTag(this.tag.id, {
            email: user,
          })

          this.$message({
            type: "success",
            message: "Đã hủy chia sẻ",
          })
          this.$emit("success")
        } catch (e) {
          this.$message({
            message: e.response.data.description,
            type: "error",
          })
        }
      })
    },
  },
  watch: {
    email: async function (val) {
      if (val === "") this.isStartCheck = false
      else {
        let resEmail = await getEmailExistenceInfo(val)

        if (resEmail == null) {
          this.$message({
            message: "Có lỗi xảy ra khi kiểm tra Email",
            type: "error",
          })
        } else {
          this.isRealEmail = resEmail
        }
      }
    },
  },
}
</script>

<style scoped>
.date-picker {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: hidden;
}

.el-form-item__label {
  font-size: 18px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.icon {
  color: lightseagreen;
  cursor: pointer;
}

.shared-tag {
  margin: 5px;
}
</style>
